import { render, staticRenderFns } from "./FormulateTreeSelect.vue?vue&type=template&id=0632b03f&"
import script from "./FormulateTreeSelect.js?vue&type=script&lang=js&"
export * from "./FormulateTreeSelect.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/staging.mijnmooiestraat.vlaanderen/pro-staging.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0632b03f')) {
      api.createRecord('0632b03f', component.options)
    } else {
      api.reload('0632b03f', component.options)
    }
    module.hot.accept("./FormulateTreeSelect.vue?vue&type=template&id=0632b03f&", function () {
      api.rerender('0632b03f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Formulate/FormulateTreeSelect/FormulateTreeSelect.vue"
export default component.exports